const state = {
	dialogPaymentMethod:			false,
	dialogAddCard:					false,
	dialogAddProduct:				false,
	dialogEditProducts:				false,
	dialogRemoveCardConfirmation:	false,
	dialogChangeStatus:				false,
	dialogCancelSubscription:		false,
	dialogSubscriptionEdit:			false,
	dialogCharge:					false,
	dialogFeedback:					false
}

const mutations = {
	setDialogPaymentMethod(state, content){
		state.dialogPaymentMethod = content;
	},

	setDialogAddCard(state, content){
		state.dialogAddCard = content;
	},

	setDialogAddProduct(state, content){
		state.dialogAddProduct = content;
	},

	setDialogEditProducts(state, content){
		state.dialogEditProducts = content;
	},

	setDialogRemoveCardConfirmation(state, content){
		state.dialogRemoveCardConfirmation = content;
	},

	setDialogChangeStatus(state, content){
		state.dialogChangeStatus = content;
	},

	setDialogCancelSubscription(state, content){
		state.dialogCancelSubscription = content;
	},

	setDialogSubscriptionEdit(state, content) {
		state.dialogSubscriptionEdit = content;
	},

	setDialogCharge(state, content) {
		state.dialogCharge = content;
	},

	setDialogFeedback(state, content) {
		state.dialogFeedback = content;
	}
}

export default {
	namespaced: true,
	state,
	mutations
};